module.exports = __webpack_public_path__ + "img/icon_diamond.8c8ff870.png";